import { useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const AuthCallback = () => {
  const { completeGoogleLogin } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  const run = useCallback(async () => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    try {
      await completeGoogleLogin(m[1]);
      window.history.replaceState({}, "", window.location.pathname);
      navigate("/dashboard", { replace: true });
    } catch (e) {
      console.error("AuthCallback failed", e);
      navigate("/login?error=oauth", { replace: true });
    }
  }, [completeGoogleLogin, navigate]);

  useEffect(() => {
    run();
  }, [run]);

  return (
    <div className="min-h-screen flex items-center justify-center text-zinc-400 font-mono text-xs uppercase tracking-[0.3em]" data-testid="auth-callback">
      Establishing secure channel...
    </div>
  );
};

export default AuthCallback;
